import { QRCodeCanvas } from "qrcode.react";

const QRGenerator = ({ user }) => {
  if (!user) return null;

  const vCardURL = `${process.env.REACT_APP_FRONTEND_URL}vcards/${user.slug}`;
  return <QRCodeCanvas value={vCardURL} />;
};

export default QRGenerator;